module.exports = __webpack_public_path__ + "img/c2.c1e9efcd.png";